import { Grid } from "@mui/material";
import { ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";
import Field from "../../component/Field";
import Label from "../../component/Label";

const ParentLinkRegistrationPayment = (props: any) => {
  const { values, setFieldValue, parentLinkInfo, errors, touched } = props;
  const { handleChange, handleBlur } = props;
  // const totalAmountToBePaid =
  //   parseFloat(values.invoiceAmount) - parseFloat(values.discountAmount);

  const { t } = useTranslation();

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={{ padding: "10px" }}
    >
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <div className="form-ele-gap">
          <Label title={t("invoiceAmount")} />
          <Field
            className="textFiled"
            name="invoiceAmount"
            disabled
            value={values.invoiceAmount}
          />
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <div className="form-ele-gap">
          <Label title={t("discountAmt")} />
          <Field
            className="textFiled"
            name="discountAmount"
            disabled
            value={values.discountAmount}
          />
        </div>
      </Grid>
      {parentLinkInfo?.showPayNow && (
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <div className="form-ele-gap inherit-number-field">
            <Label title={t("totalAmountToBePaid")} />
            <Field
              className="textFiled"
              type="number"
              name="totalAmountToBePaid"
              value={values.totalAmountToBePaid} //|| totalAmountToBePaid.toFixed(2)
              onChange={handleChange}
              onKeyUp={(e: any) => {
                if (Number(e.target.value) < 0)
                  setFieldValue("totalAmountToBePaid", 0);
              }}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="totalAmountToBePaid" />}
              error={errors.totalAmountToBePaid && touched.totalAmountToBePaid}
            />
          </div>
        </Grid>
      )}
    </Grid>
  );
};

export default ParentLinkRegistrationPayment;
